module.exports = __webpack_public_path__ + "media/images/icon__breadcrumbs-arrow-left--rb-raven-gray@3x-d1cb59e0bf8499728cb77153d74f6bf4.png";